import { useEffect, useRef, useState } from 'react'
import './index.scss'
import { Result, Spin } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import Api from '../../api/index'
import {
  WECHAT_QR_EXPIRED_CODE,
  clearWechatInfoRequest,
  clearWechatQrSession,
  createWechatInfoParams,
  getApiCode,
  getApiPayload,
  getErrorCode,
  getWechatQrHandoff,
  isWechatQrHandoffReady,
  requestWechatInfoOnce,
  saveWechatQrHandoff,
} from '../../utils/wechatQr'

export default function WXLogin() {
  const { scan_id: scanId } = useParams()
  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const [expired, setExpired] = useState(false)
  const infoRequestedRef = useRef(null)
  const completedRef = useRef(false)

  useEffect(() => {
    document.title = 'iWudao'
    const params = createWechatInfoParams(scanId, window.location.search)
    const savedHandoff = getWechatQrHandoff()

    if (isWechatQrHandoffReady(savedHandoff, scanId)) {
      completedRef.current = true
      history.replace('/wxHtml')
      return undefined
    }
    if (savedHandoff) clearWechatQrSession()

    if (!params.scan_id || !params.code || !params.state) {
      setExpired(true)
      setLoading(false)
      return undefined
    }
    if (infoRequestedRef.current === scanId) return undefined
    infoRequestedRef.current = scanId
    completedRef.current = false

    let active = true
    requestWechatInfoOnce(scanId, () =>
      Api.getWechatInfo(params.scan_id, params.code, params.state)
    )
      .then((res) => {
        if (!active || completedRef.current) return
        if (getApiCode(res) === 0) {
          const info = getApiPayload(res)
          if (
            info?.status === 'verified' ||
            info?.status === 'registration_required'
          ) {
            saveWechatQrHandoff(scanId, info)
            if (isWechatQrHandoffReady(getWechatQrHandoff(), scanId)) {
              completedRef.current = true
              clearWechatInfoRequest(scanId)
              history.replace('/wxHtml')
              return
            }
          }
        }
        if (isWechatQrHandoffReady(getWechatQrHandoff(), scanId)) {
          completedRef.current = true
          history.replace('/wxHtml')
          return
        }
        if (getApiCode(res) === WECHAT_QR_EXPIRED_CODE) {
          setExpired(true)
        }
        setLoading(false)
      })
      .catch((error) => {
        if (!active || completedRef.current) return
        if (isWechatQrHandoffReady(getWechatQrHandoff(), scanId)) {
          completedRef.current = true
          history.replace('/wxHtml')
          return
        }
        if (getErrorCode(error) === WECHAT_QR_EXPIRED_CODE) {
          setExpired(true)
        }
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [history, scanId])

  return (
    <div className="wxLoginContent">
      {loading ? (
        <Spin size="large" />
      ) : (
        <Result
          title={expired ? '请重新扫描二维码!' : '微信授权未完成，请重试!'}
        />
      )}
    </div>
  )
}
